import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {ModuleService} from '../../services/module.service';
import * as fromStore from '../../store';
import {Store, Action} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as actions from '../actions';
import {map, switchMap, withLatestFrom} from 'rxjs/operators';
import {UtilsService} from '../../services/utils.service';
import { UserModuleActions } from '../actions/user-module.actions';

@Injectable()
export class UserModuleEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private moduleService = inject(ModuleService);
  private utils = inject(UtilsService);

  constructor() {}

  getUserModules$ = createEffect(() => this.actions$.pipe(
    ofType<actions.GetUserModules>(actions.UserModuleActionTypes.GetUserModlues),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = (action && action.payload && action.payload.force) ?
        { otp: user.otp, force: true } : { otp: user.otp };
      return this.moduleService.ReadModuleByUser(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            const token = JSON.parse(this.utils.getToken());
            this.utils.writeToken({...token, authority: res.msg.body.Authority});
            if (action && action.payload && action.payload.isLoadPlan) {
              return [new actions.LoadUserModules(res.msg.body.Modules)];
            } else {
              return [new actions.LoadUserModules(res.msg.body.Modules),
                new actions.GetAdmin({authority: res.msg.body.Authority, AuthorityRegion: res.msg.body.AuthorityRegion})];
            }
          }
        })
      );
    })
  ));
}
